import React from 'react';
import { motion } from 'framer-motion';
import { cn } from '../lib/utils';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiSearch } = FiIcons;

const GlowInput = ({ value, onChange, placeholder, className, accentColor = '#c2ffe0', isDark = true }) => {
  const bgFrom = isDark ? '#1a1a1a' : '#ffffff';
  const bgTo = isDark ? '#141414' : '#f5f5f5';
  const borderIdle = isDark ? '#333333' : '#dddddd';
  const iconColor = isDark ? '#a3a3a3' : '#888888';
  const textColor = isDark ? '#ffffff' : '#111111';
  const placeholderClass = isDark ? 'placeholder-[#a3a3a3]' : 'placeholder-[#888888]';

  return (
    <div className={cn('relative w-full', className)}>
      <div
        className="relative flex items-center border rounded-xl overflow-hidden transition-all duration-300 shadow-lg"
        style={{
          background: `linear-gradient(135deg, ${bgFrom}, ${bgTo})`,
          borderColor: value ? `${accentColor}80` : borderIdle,
        }}
      >
        <SafeIcon
          icon={FiSearch}
          className="absolute left-4 w-4 h-4 pointer-events-none"
          style={{ color: iconColor }}
        />
        <input
          type="text"
          value={value}
          onChange={onChange}
          className={`w-full bg-transparent px-12 py-4 outline-none text-sm font-medium tracking-wide ${placeholderClass}`}
          placeholder={placeholder}
          style={{ color: textColor }}
        />
        <motion.div
          className="absolute bottom-0 left-0 h-[2px] bg-gradient-to-r from-transparent via-current to-transparent"
          style={{ color: accentColor }}
          initial={{ width: '0%', opacity: 0 }}
          animate={{ width: value ? '100%' : '0%', opacity: value ? 1 : 0 }}
          transition={{ duration: 0.3 }}
        />
      </div>
    </div>
  );
};

export default GlowInput;